export const READONLY_CHANGE_EVENT = 'slab-readonly-change';

export const LINK_TYPE_ATTRIBUTE = 'data-slab-linktype';
export const LINK_TYPES = {
  embed: 'embed',
  text: 'text',
  mention: 'mention',
  iframe: 'iframe',
};
